import { render, staticRenderFns } from "./btnClip.vue?vue&type=template&id=73dec0fa&scoped=true"
import script from "./btnClip.vue?vue&type=script&lang=js"
export * from "./btnClip.vue?vue&type=script&lang=js"
import style0 from "./btnClip.vue?vue&type=style&index=0&id=73dec0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dec0fa",
  null
  
)

export default component.exports